import axios from 'axios';

let URL = 'https://intense-peak-75508.herokuapp.com';

if (process.env.NODE_ENV !== 'production') { URL = 'http://localhost:5000'; }

const http = axios.create({
  baseURL: `${URL}/api`,
  timeout: 30000,
});

export const getURL = () => URL;

export const alterHeader = (token) => {
  http.defaults.headers = {
    Authorization: token,
  };
};

export default http;
